import { LayoutMoon, TopNav, TopNavItem } from '@orobix/orobix-fe-components'
import i18n from 'i18next'
import { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'

import endUserManualEN from '../assets/ai-go-studio-end-user-manual.pdf'
import endUserManualIT from '../assets/ai-go-studio-manuale-utente.pdf'
import { msalInstance } from '../auth/config'
import AppInfo from '../components/AppInfo/AppInfo'
import EnvInfo from '../components/EnvInfo/EnvInfo'
import LicenseAgreementModal from '../components/LicenseAgreementModal/LicenseAgreementModal'
import { SettingsContext } from '../components/Settings'
import SettingsModal from '../components/Settings/SettingsModal'
import useSettings from '../components/Settings/useSettings'
import WhatsNewModal from '../components/WhatsNewModal/WhatsNewModal'
import { vars } from '../utils/appConfig'
import { getEnvs } from '../utils/env'
import { locations } from '../utils/locations'

interface LoggedInTemplateProps {
  children: React.ReactChildren
}

const { showEnvBadge } = getEnvs()

const LoggedInTemplate = ({ children }: LoggedInTemplateProps): JSX.Element => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const account = msalInstance.getActiveAccount()
  const [whatsNewModal, setWhatsNewModal] = useState(false)
  const [settingsModal, setSettingsModal] = useState(false)
  const [licenseModal, setLicenseModal] = useState(false)

  // Load settings at startup
  const { settings } = useSettings()
  const { updateSettings } = useContext(SettingsContext)
  useEffect(() => {
    if (settings) {
      updateSettings(settings)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings])

  const handleMenuClick = useCallback((where: string) => history.push(where), [
    history,
  ])

  return (
    <>
      <LayoutMoon
        appName={vars.appName}
        subTitle="by Orobix"
        info={<AppInfo />}
        envBadge={showEnvBadge && <EnvInfo />}
        showUser
        userFullName={account ? account.name : ''}
        userEmail={account ? account.username : ''}
        userInitials={account && account.name ? account.name.charAt(0) : ''}
        userMenuItems={[
          {
            type: 'link',
            label: t('End user manual (PDF)'),
            href: i18n.language.startsWith('it')
              ? endUserManualIT
              : endUserManualEN,
            target: '_blank',
          },
          {
            type: 'button',
            label: t('End user license (PDF)'),
            onClick: () => setLicenseModal(true),
          },
          {
            type: 'button',
            label: t('Settings'),
            onClick: () => setSettingsModal(true),
          },
          {
            type: 'button',
            label: t('Logout'),
            onClick: () =>
              msalInstance.logoutPopup().then(() => {
                history.push(locations.signIn)
              }),
          },
        ]}
        header={
          <TopNav>
            <TopNavItem
              active={location.pathname.startsWith(locations.projects)}
              label={t('Projects')}
              onClick={() => handleMenuClick(locations.projects)}
            />
            <TopNavItem
              active={location.pathname.startsWith(locations.search)}
              label={t('Search')}
              onClick={() => handleMenuClick(locations.search)}
            />
            <TopNavItem
              label={t("What's new")}
              onClick={() => setWhatsNewModal(true)}
            />
          </TopNav>
        }
        content={children}
      />
      {whatsNewModal && (
        <WhatsNewModal onCloseRequest={() => setWhatsNewModal(false)} />
      )}
      {settingsModal && (
        <SettingsModal onCloseRequest={() => setSettingsModal(false)} />
      )}
      {licenseModal && (
        <LicenseAgreementModal onClose={() => setLicenseModal(false)} />
      )}
    </>
  )
}

export default LoggedInTemplate
